module.exports = __webpack_public_path__ + "img/shop@2x.2d403355.png";